import React, { useContext } from 'react'
import CreationSourceURLField from '../../../../../../components/form-fields/upload/source-url'
import styled from 'styled-components'
import { CreationCaptureInfoContext } from '../manager'
import CreationToolUploadField from '../../../../../../types/upload-field'

const SourceURL = styled(CreationSourceURLField)`
    grid-column: span 2;
`

type Props = {
    className?: string
    field: CreationToolUploadField
}

const CreationCaptureInfoSourceUrlField = ({ className, field }: Props) => {
    const { sourceUrl, setSourceUrl } = useContext(CreationCaptureInfoContext)

    return (
        <SourceURL
            {...{
                className,
                field,
                sourceUrl,
                showInstructions: true,
                onChange: setSourceUrl,
            }}
        />
    )
}

export default CreationCaptureInfoSourceUrlField
